import React, { useState, useEffect } from 'react';
import EmailRoutingPathList from './EmailRoutingPathList'
import EmailRoutingPathMap from './EmailRoutingPathMap'
import CollapsibleCard from '../common/CollapsibleCard'
import { getReceivedFromGeoLocationsAsync } from "../../../helpers/geo"
import { getUserProfile } from "../../../helpers/mailbox"
import { isPaiedUser, contactDtonomy } from "../../../helpers/get_permission"

export default function EmailRoutingPathCard() {
  const [geolocations, setGeolocations] = useState([]);
  const [payment, setPayment] = useState(false);
  useEffect(() => {
    let userEmail = getUserProfile().emailAddress;
        isPaiedUser(userEmail).then(
            paid => {
                if(paid) {
                    setPayment(true);
                } else {
                    setPayment(false);
                }
            }
        )
    async function getGeolocationsAsync() {
      const geo = await getReceivedFromGeoLocationsAsync();
      setGeolocations(geo);
    }
    getGeolocationsAsync();
  }, []);
  //  comment out for free user
  // if (!payment) {
  //   return (
  //     <CollapsibleCard header="Email Routing Path" ctrlName="emailRoutingPath" isOpen={true}>
  //       <div className="overlay">
  //         <small className="font-weight-bold">Please contact <a href="" onClick={contactDtonomy} target="_blank" rel="noreferrer">DTonomy Inc.</a> to unlock the content</small>
  //       </div>
  //       <p className="blur">
  //         The following map and text show the locations of the servers that the email was routed through before reaching the final destination.
  //       </p>
  //     </CollapsibleCard>
  //   )

  // } 

    if (geolocations.length > 0) {
      return (
        <CollapsibleCard header="Email Routing Path" ctrlName="emailRoutingPath" isOpen={true}>
          <p className="card-text">
            The following map and text show the locations of the servers that the email was routed through before reaching the final destination.
          </p>
          <EmailRoutingPathMap geolocations={geolocations}></EmailRoutingPathMap>
          <EmailRoutingPathList geolocations={geolocations}></EmailRoutingPathList>
        </CollapsibleCard>
      );
    }
    else {
      return (
        <CollapsibleCard header="Email Routing Path" ctrlName="emailRoutingPath" isOpen={true}>
          <span className="font-weight-bold">
            No routing path locations found.
          </span>
        </CollapsibleCard>
      );
    }
}
